import { PackageDto } from "../dtos";

export class Package {
  id = -1;
  image: string | null = null;
  name = "";
  capacity = 0;
  customer_can_change_order: boolean | undefined = false;
  description: string | null = null;
  activities: { id: number; name: string }[] = [];
  supplements: {
    id: number;
    name: string;
    visible: boolean;
    quantity: number;
    description: string;
    avatar: string | null;
    servingActivities: number[] | null;
  }[] = [];

  constructor(dto: PackageDto) {
    this.id = dto.id;
    this.image = dto.avatar ?? null;
    this.name = dto.name;
    this.capacity = dto.capacity;
    this.customer_can_change_order = dto.customer_can_change_order;
    this.description = dto.description ?? null;
    this.activities = dto.activities
      .sort((a, b) => a.order_column - b.order_column)
      .map(({ activity_id, activity_name, order_column }) => ({
        order: order_column,
        id: activity_id,
        name: activity_name,
      }));

    this.supplements = dto.supplements.map((item) => {
      return {
        id: item.id,
        quantity: item.quantity,
        name: item.name,
        description: item.description,
        avatar: item.avatar,
        visible: item.public_visibility,
        servingActivities:
          item.serving_activities.length > 0 ? item.serving_activities : null,
      };
    });
  }
}
